import { FormField } from "@components/FormEngine/types";
import { z } from "zod";
import { baseSleepQuestionnaireSchema } from "./sleepQuestionnaireSchema";

export const sleepUpdateSchema: FormField[] = [
	...baseSleepQuestionnaireSchema,
	{
		// My Sleep Status
		type: "radio",
		name: "sleepQuestionnaire.sleepStatus",
		title: "My Sleep Status",
		fieldProps: {
			options: [
				"Better", 
				"Worse", 
				"About the same"
			].map(s => ({ label: s, value: s }))
		},
		description: "Compared to before your last visit, how would you rate your sleep?",
		rule: z.string().min(1, "Please select an option")
	}
]

export default sleepUpdateSchema;